// config.js文件用来存放后端请求接口地址
export default {
  baseUrl: {
	// dev: 'http://192.168.0.103:8881/apis' // 开发环境
	// pro: 'https://m.shiyueji.net/apis'//预发布
	pro: "https://platform.shiyueji.net/apis" //生产环境
  }
}